/**
 * Cart quantity limits (`_limit:N` product tags) for drawer and /cart page.
 * Ported from production cart-limit-enforcement (native line-item / quantity-selector DOM).
 */
(function () {
  var ENFORCEMENT_DELAY_MS = 1000;
  var SYNC_DEBOUNCE_MS = 80;

  function isInsideCartLimitsRoot(node) {
    if (!node || !node.closest) return false;
    return node.closest('#cart-drawer') != null || node.closest('form.cart-page') != null;
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function fixLimitedItemQuantity(variantId, limit) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var updates = {};
    updates[variantId] = limit;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        refreshCart();
      })
      .catch(function (err) {
        console.error('Error enforcing limited quantity:', err);
      });
  }

  function quantityInputForLineItem(item) {
    return item.querySelector('.quantity-selector__input');
  }

  function updateLimitReachedClass(item) {
    var limit = parseInt(item.getAttribute('data-limit') || '0', 10);
    var input = quantityInputForLineItem(item);
    var quantity = parseInt((input && input.value) || '0', 10);
    if (limit && quantity >= limit) {
      item.classList.add('limit-reached');
    } else {
      item.classList.remove('limit-reached');
    }
  }

  function syncAllLimitReachedClasses() {
    document.querySelectorAll('line-item.line-item[data-limit]').forEach(updateLimitReachedClass);
  }

  function enforceLimitedQuantities() {
    document.querySelectorAll('line-item.line-item[data-limit]').forEach(function (item) {
      if (!isInsideCartLimitsRoot(item)) return;
      var limit = parseInt(item.getAttribute('data-limit') || '0', 10);
      var variantId = item.getAttribute('data-variant-id');
      var input = quantityInputForLineItem(item);
      var quantity = parseInt((input && input.value) || '0', 10);
      if (!limit || !variantId) return;
      if (quantity > limit) {
        fixLimitedItemQuantity(variantId, limit);
      }
    });
    syncAllLimitReachedClasses();
  }

  function scheduleEnforcement() {
    window.setTimeout(enforceLimitedQuantities, ENFORCEMENT_DELAY_MS);
  }

  function handleQuantityChange(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!isInsideCartLimitsRoot(t)) return;
    var item = t.closest('line-item.line-item');
    if (!item || !item.hasAttribute('data-limit')) return;
    var qs = t.closest('.quantity-selector');
    if (!qs || !qs.contains(t)) return;
    updateLimitReachedClass(item);
  }

  document.documentElement.addEventListener('input', handleQuantityChange, true);
  document.documentElement.addEventListener('change', handleQuantityChange, true);

  var observer = new MutationObserver(function (mutations) {
    var needsSync = mutations.some(function (m) {
      var node = m.target;
      return isInsideCartLimitsRoot(node);
    });
    if (!needsSync) return;
    clearTimeout(observer._limitSyncId);
    observer._limitSyncId = setTimeout(syncAllLimitReachedClasses, SYNC_DEBOUNCE_MS);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(syncAllLimitReachedClasses, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function initCartLimits() {
      syncAllLimitReachedClasses();
      scheduleEnforcement();
    });
  } else {
    syncAllLimitReachedClasses();
    scheduleEnforcement();
  }

  document.addEventListener('product:added', scheduleEnforcement);
})();

/** Change a cart line's purchase option without affecting another line of the same variant. */
(function () {
  var updating = false;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function restoreField(field) {
    var currentPlan = field.getAttribute('data-current-plan-id') || '';
    var toggle = field.querySelector('.line-item__subscription-toggle input');
    var frequency = field.querySelector('.line-item__subscription-frequency');
    if (toggle) toggle.checked = Boolean(currentPlan);
    frequency.value = currentPlan;
    frequency.disabled = false;
  }

  function setControlsDisabled(disabled) {
    document.querySelectorAll('.line-item__subscription').forEach(function (field) {
      var toggle = field.querySelector('.line-item__subscription-toggle input');
      var frequency = field.querySelector('.line-item__subscription-frequency');
      if (toggle) toggle.disabled = disabled;
      frequency.disabled = disabled;
    });
  }

  async function updateSellingPlan(field, planId) {
    updating = true;
    field.setAttribute('aria-busy', 'true');
    field.querySelector('.line-item__subscription-error').hidden = true;
    setControlsDisabled(true);

    try {
      var cartResponse = await fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Could not load the cart. Please try again.');
      var cart = await cartResponse.json();
      var lineIndex = cart.items.findIndex(function (item) {
        return item.key === field.getAttribute('data-line-key');
      });
      if (lineIndex < 0) throw new Error('The cart changed. Please refresh and try again.');

      var response = await fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          line: lineIndex + 1,
          quantity: cart.items[lineIndex].quantity,
          selling_plan: planId ? Number(planId) : null
        })
      });
      if (!response.ok) {
        var error = await response.json().catch(function () { return {}; });
        throw new Error(error.description || 'Could not update the purchase option. Please try again.');
      }

      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (error) {
      restoreField(field);
      var message = field.querySelector('.line-item__subscription-error');
      message.textContent = error.message || 'Could not update the purchase option. Please try again.';
      message.hidden = false;
    } finally {
      field.removeAttribute('aria-busy');
      setControlsDisabled(false);
      updating = false;
    }
  }

  document.addEventListener('change', function (event) {
    var control = event.target;
    if (!control.matches || !control.matches('.line-item__subscription-toggle input, .line-item__subscription-frequency')) return;
    var field = control.closest('.line-item__subscription');
    if (!field || updating) return;

    var toggle = field.querySelector('.line-item__subscription-toggle input');
    var frequency = field.querySelector('.line-item__subscription-frequency');
    // Mau (Joel, 2026-10-29): the frequency menu works while Subscribe & Save is unticked; choosing a frequency ticks
    // it and applies the plan in one go (the menu used to be disabled until the box was ticked)
    if (control === frequency && toggle && !toggle.checked && frequency.value) toggle.checked = true;
    var subscribed = !toggle || toggle.checked;

    if (!subscribed) {
      if (!field.getAttribute('data-current-plan-id')) {
        frequency.value = '';
        return;
      }
      updateSellingPlan(field, null);
      return;
    }

    var planId = frequency.value || field.getAttribute('data-only-plan-id');
    if (!planId) {
      frequency.focus();
      return;
    }
    if (planId === field.getAttribute('data-current-plan-id')) return;
    updateSellingPlan(field, planId);
  });
})();

/**
 * PDP / featured product: disable add-to-cart when the cart quantity for the selected variant reaches the
 * product tag limit (`_limit:N`). Uses `data-purchase-limit` on `<buy-buttons>` (set in Liquid). Syncs via cart.js.
 * Ported from production purchaseLimitCartSync (native buy-buttons / product-form DOM).
 */
(function () {
  var SYNC_DEBOUNCE_MS = 120;
  var RERENDER_SYNC_DELAY_MS = 600;
  var PRODUCT_ADDED_ENFORCE_DELAY_MS = 1200;
  var LIMITED_SELECTOR = 'buy-buttons[data-purchase-limit]';
  var MARKER = 'data-disabled-by-purchase-limit';

  var scheduleTimer = null;

  function fieldValue(form, name) {
    var field = form.elements[name];
    return field ? field.value : null;
  }

  function fetchCartJson() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function cartQtyForVariant(cart, variantId) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (total, item) {
      return parseInt(item.variant_id, 10) === variantId ? total + item.quantity : total;
    }, 0);
  }

  function syncContainer(container, cart) {
    var limit = parseInt(container.getAttribute('data-purchase-limit') || '0', 10);
    var form = document.forms[container.getAttribute('form')];
    if (!limit || !form) return;

    var variantId = parseInt(fieldValue(form, 'id'), 10);
    if (!variantId) return;

    var intended = parseInt(fieldValue(form, 'quantity'), 10);
    if (!intended || intended < 1) intended = 1;

    var cartQty = cartQtyForVariant(cart, variantId);
    var exceeds = cartQty >= limit || cartQty + intended > limit;

    var btn = container.querySelector('button[type="submit"]');
    var paymentWrap = container.querySelector('.shopify-payment-button');

    container.classList.toggle('is-purchase-limit-reached', exceeds);

    if (exceeds) {
      // Leave buttons that are already disabled (sold out / unavailable) untouched
      if (btn && !btn.disabled) {
        btn.disabled = true;
        btn.setAttribute(MARKER, 'true');
      }
      if (paymentWrap && !paymentWrap.hasAttribute(MARKER)) {
        paymentWrap.setAttribute(MARKER, 'true');
        paymentWrap.style.display = 'none';
      }
    } else {
      if (btn && btn.hasAttribute(MARKER)) {
        btn.removeAttribute(MARKER);
        btn.disabled = false;
      }
      if (paymentWrap && paymentWrap.hasAttribute(MARKER)) {
        paymentWrap.removeAttribute(MARKER);
        paymentWrap.style.display = '';
      }
    }
  }

  function syncAll() {
    var containers = document.querySelectorAll(LIMITED_SELECTOR);
    if (!containers.length) return;
    fetchCartJson()
      .then(function (cart) {
        containers.forEach(function (container) {
          syncContainer(container, cart);
        });
      })
      .catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(syncAll, SYNC_DEBOUNCE_MS);
  }

  // Variant changes re-render the buy buttons from the server, so sync again once the new markup is in
  function scheduleSyncAfterRerender() {
    scheduleSync();
    setTimeout(scheduleSync, RERENDER_SYNC_DELAY_MS);
  }

  function handleQuantityChange(e) {
    var t = e.target;
    if (!t || t.name !== 'quantity' || !t.form) return;
    if (!document.querySelector(LIMITED_SELECTOR + '[form="' + t.form.id + '"]')) return;
    scheduleSync();
  }

  function boot() {
    syncAll();

    document.addEventListener('cart:change', scheduleSync);
    document.addEventListener('cart:refresh', scheduleSync);
    document.addEventListener('variant:change', scheduleSyncAfterRerender, true);
    document.addEventListener('product:rerender', scheduleSyncAfterRerender, true);
    document.addEventListener('input', handleQuantityChange, true);
    document.addEventListener('change', handleQuantityChange, true);

    document.addEventListener('product:added', function () {
      scheduleSync();
      setTimeout(scheduleSync, PRODUCT_ADDED_ENFORCE_DELAY_MS);
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) scheduleSync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
